import type { CommentId } from '@atlassian/jira-issue-view-common-types/src/comment-type';

export const NEW_COMMENT_ID: CommentId = 'NEW_OPTIMISTIC_COMMENT';
